import { Component, inject } from '@angular/core';
import { AppBackButton } from '@hunting-nature/shared-ui/components/app-back-button/app-back-button';
import { IfNativeDirective } from '@hunting-nature/shared-ui/directives/if-native.directive';
import { IonButtons, IonContent, IonHeader, IonItem, IonList, IonListHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { Store } from '@ngrx/store';

import { GeneralActions } from '../../../../shared/redux/general/general.actions';

import { DeleteCacheComponent } from './components/delete-cache/delete-cache.component';
import { StorageInformationComponent } from './components/storage-information/storage-information.component';

@Component({
  selector: 'app-storage-management',
  templateUrl: './storage-management.page.html',
  styleUrls: ['./storage-management.page.scss'],
  standalone: true,
  imports: [
    IonListHeader,
    IonItem,
    IonList,
    TranslocoPipe,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    StorageInformationComponent,
    IfNativeDirective,
    DeleteCacheComponent,
    IonButtons,
    AppBackButton,
  ],
})
export class StorageManagementPage {
  // services
  private readonly store = inject(Store);

  // UI handlers
  handleGoBack(): void {
    this.store.dispatch(GeneralActions.goBackToMenuFromStorageManagement());
  }
}
